import { DEFAULT_LOCALE } from '@/utils/constants';

export const localePath = (path: string | null | undefined, locale: string): string | undefined => {
  if (!path) return undefined;

  if (path.startsWith('http://') || path.startsWith('https://')) return path;

  if (locale === DEFAULT_LOCALE) return path;

  const prefix = `/${locale}`;
  if (path === prefix || path.startsWith(`${prefix}/`)) return path;

  // `/` → `/pl`, not `/pl/` (which would cost a trailing-slash redirect).
  return path === '/' ? prefix : `${prefix}${path}`;
};
